import { useHandler } from "@redotech/react-util/hook";
import { DraftReturnShipment } from "@redotech/redo-model/draft-return/draft-return";
import { createContext, ReactNode, useContext, useState } from "react";
import { ReturnContext } from "./return";
import { RpcClientContext } from "./rpc";
export interface ShippingEstimateData {
  getShipments: () => Promise<DraftReturnShipment[]>;
  deleteCache: () => void;
  updateShipments: (shipmentsPromise: Promise<DraftReturnShipment[]>) => void;
}
export const ShippingEstimateContext = createContext<ShippingEstimateData>({
  getShipments: () => Promise.resolve([]),
  deleteCache: () => {},
  updateShipments: (shipmentsPromise: Promise<DraftReturnShipment[]>) => {},
});

export const ShippingEstimateProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const rpc = useContext(RpcClientContext);
  const draftReturn = useContext(ReturnContext);
  const [shipments, setShipments] = useState<
    Promise<DraftReturnShipment[]> | undefined
  >(undefined);

  const getShipments = useHandler(async () => {
    if (!draftReturn.draftReturn?._id || !rpc) {
      return [];
    }

    if (shipments) {
      return shipments;
    }

    const shipmentsPromise = rpc
      .getShippingEstimate({ draftReturnId: draftReturn.draftReturn._id })
      .catch((error) => {
        setShipments(undefined);
        throw error;
      });

    setShipments(shipmentsPromise);

    return shipmentsPromise;
  });
  return (
    <ShippingEstimateContext.Provider
      value={{
        getShipments,
        deleteCache: () => setShipments(undefined),
        updateShipments: (shipmentsPromise) => setShipments(shipmentsPromise),
      }}
    >
      {children}
    </ShippingEstimateContext.Provider>
  );
};
